<script lang="ts">
    import { DateTime } from 'luxon'; 
    import { locale, t } from 'svelte-i18n';
  
    export let dateString: string | null | undefined;
  
    $: currentLocale = $locale ?? 'en';
  
    function timeSince(dateString: string | null | undefined, locale: string): string {
		if (dateString) {
			
			const date = DateTime.fromISO(dateString, { locale: locale, zone: 'utc' });
			const now = DateTime.now().toUTC();
			const diff = now.diff(date, ['years', 'months', 'days', 'hours', 'minutes']).toObject();

			if (diff.years) {
				return date.toFormat('dd MMMM yyyy');
			}
			if (diff.months) {
				if( diff.months < 4 )
					return date.toFormat('dd MMMM');
				else
					return date.toFormat('dd MMMM yyyy');
			}
			if (diff.days) {
				if( diff.days > 1 ) {
					if( diff.days < 10 ) 
						return $t('global.time.daysAgo', { values: {count: diff.days } }) + ', ' + date.weekdayLong;
					else 
						return date.toFormat('dd MMMM');
				}
				else
					return $t('global.time.dayAgo') + ', ' + date.weekdayLong;
			} 
			if (diff.hours) {
				if( diff.hours > 1 )	
					return $t('global.time.hoursAgo', { values: {count: diff.hours } });
				else
					return $t('global.time.hourAgo');
			} 
			if (diff.minutes) {
				if( diff.minutes > 1 )	
					return $t('global.time.minutesAgo', { values: {count: Math.round(diff.minutes) } });
				else
					return $t('global.time.minuteAgo');
			}
			return $t('global.time.justNow');
		}
		return '';
  	}
  </script>
  
  {timeSince(dateString, currentLocale)}
  